module.exports = __webpack_public_path__ + "static/media/double-upGreen.86692450.svg";